export const DEFAULT_JSX_OPTIONS = {
    dynamicReferencePrefixMap: {
        prop: '',
        state: '',
        local: '',
    },
    dependencyHandling: 'import',
    stateHandling: 'mutation',
    slotHandling: 'native',
};
//# sourceMappingURL=constants.js.map